import {
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Stack,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useUserManagement } from '../../features/UserManagement/components/UserManagementContext';
import LogoutIcon from '@mui/icons-material/Logout';

export default function Menu() {
  const { identity } = useUserManagement();
  const { t } = useTranslation();

  const handleLogout = () => {
    identity.actions?.logout();
  };

  return (
    <Stack sx={{ paddingY: 1 }}>
      <Box sx={{ paddingX: 2 }}>
        <Typography variant='body2'>
          {t('readingView.account.authenticated.label')}
        </Typography>
        <Typography variant='subtitle2'>{identity.user?.email}</Typography>
      </Box>
      <Divider sx={{ marginY: 1 }} />
      <MenuList>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText>{t('readingView.account.logout.cta')}</ListItemText>
        </MenuItem>
      </MenuList>
    </Stack>
  );
}
